import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/portal/settings")({
  // ?tab=team deep-links the Settings "Team" tab; anything else is Notifications.
  validateSearch: (s: Record<string, unknown>): { tab?: "team" } => ({
    tab: s.tab === "team" ? "team" : undefined,
  }),
  component: lazyRouteComponent(() => import("@/pages/Portal/Settings/Page")),
});
